import $ from 'jquery';
import Popper from 'popper.js';
import fastdom from 'fastdom';

(function () {
  const popdownsMap = new WeakMap();

  function isDisabledLink(elem) {
    return (
      elem.classList.contains('disabled') || elem.getAttribute('data-disabled')
    );
  }

  function isSelectro(element) {
    return element.classList.contains('selectro-trigger');
  }

  function openPopdown(node) {
    const menuNode = node.getElementsByClassName('popdown__menu')?.[0];
    // Allow element to have class of popdown-bottom or top to indicate the permanant placement
    const isBottomPlacement = menuNode?.classList.contains('popdown-bottom');
    const isTopPlacement = menuNode?.classList.contains('popdown-top');

    let placement;
    if (isBottomPlacement) {
      placement = 'bottom';
    } else if (isTopPlacement) {
      placement = 'top';
    }

    const callback = () =>
      createPopdown(
        node,
        node.firstElementChild.getBoundingClientRect(),
        placement
      );
    const url =
      node.getElementsByClassName('popdown__menu')[0].attributes[
        'data-menu-url'
      ];

    const loading =
      node.getElementsByClassName('popdown__menu')[0].attributes[
        'data-menu-url-loading'
      ];
    if (loading) {
    } else if (url) {
      node
        .getElementsByClassName('fa-caret-down')[0]
        .classList.add('fa-spin', 'fa-spinner');

      node
        .getElementsByClassName('popdown__menu')[0]
        .setAttribute('data-menu-url-loading', true);
      node
        .getElementsByClassName('popdown__menu')[0]
        .removeAttribute('data-menu-url');
      $.get(url.value, function (response) {
        node
          .getElementsByClassName('popdown__menu')[0]
          .removeAttribute('data-menu-url-loading');
        node
          .getElementsByClassName('fa-caret-down')[0]
          .classList.remove('fa-spin', 'fa-spinner');
        callback();
      });
    } else {
      callback();
    }
  }

  function closePopdown(node) {
    node.classList.remove('active');
    unwrapContents(node.querySelector(':scope .popdown__menu'));
    $(document).trigger('popdown:closed', node);
    popdownsMap.delete(node);
  }

  // Close popdown menu if user mouses down anywhere on the document,
  // unless data attribute prevents user from closing it (persistent menu).
  $(document).on('mousedown', event => {
    // Do nothing if selectro-modal, datepicker, or popdown__menu is clicked upon.
    if (
      $(event.target).closest(
        '.selectro-modal, .datepicker, .popdown:not(aha-dropdown).active, .react-in-place__tags__menu, .aha-tooltip'
      ).length === 0
    ) {
      Array.from(
        document.querySelectorAll(
          '.popdown:not(aha-dropdown).active, .submenu:not(aha-dropdown).active'
        )
      ).forEach(node => {
        if (node.classList.contains('popdown--react')) return;

        const popdownTrigger = node.querySelector(':scope .popdown_trigger');
        if (
          !popdownTrigger ||
          !popdownTrigger.getAttribute('data-disable-close')
        ) {
          closePopdown(node);
        }
      });
    }
  });

  // Toggle opening and closing of popdown on click.
  $(document).on('click', '.popdown:not(aha-dropdown)', event => {
    event.stopPropagation();
    const elem = event.currentTarget;
    const trigger = elem.querySelector(':scope .popdown__trigger');

    if (elem.classList.contains('popdown--react')) return;

    if (
      !elem.classList.contains('disabled') &&
      (!trigger || !trigger.classList.contains('disabled'))
    ) {
      if (
        elem.classList.contains('popdown--contextmenu') ||
        (elem.classList.contains('active') &&
          $(event.target).closest('.popdown__menu').length === 0)
      ) {
        closePopdown(elem);
      } else {
        if (
          !elem.classList.contains('active') &&
          $(event.target).closest('.popdown__menu').length === 0
        ) {
          openPopdown(event.currentTarget);
        }
      }
    }
  });

  /**
   * Create a horitzonally placed Popper, used for submenus which builds a popdown either to
   * the left or right of the toggle item. If you are looking to build a popdown
   * above or below (like a popdown), see createPopdown.
   *
   * @param {Object} node The parent dom node of the popper
   * @param {Object} rect The anchor dom node for placing the popper
   */
  function createSubmenu(node, rect) {
    createPopper({
      node,
      rect,
      lessDirection: 'left-start',
      moreDirection: 'right-start',
    });
  }

  /**
   * Create a vertically placed Popper, used for popdowns, which builds a popdown either
   * above or below the toggle item. If you are looking to build a popdown to the left
   * or right (like a submenu), see createSubmenu.
   *
   * @param {Object} node The parent dom node of the popper
   * @param {Object} rect The anchor dom node for placing the popper
   */
  function createPopdown(node, rect, permenantPlacement) {
    const calculatedPlacement =
      rect.top + rect.height / 2 > window.innerHeight / 2 ? 'top' : 'bottom';

    const placement = permenantPlacement || calculatedPlacement;

    createPopper({
      node,
      rect,
      lessDirection: `${placement}-end`,
      moreDirection: `${placement}-start`,
    });
  }

  /**
   * Create a new Popper. Once the Popper is created, we wrap it with our wrapContent
   * function, where we actually give it is sizing propeties.
   *
   * @param {Object} PopperProperties Properties of the popper
   * @param {Object} PopperProperties.node The parent dom node of the popper
   * @param {Object} PopperProperties.rect The anchor dom node for placing the popper
   * @param {string} PopperProperties.lessDirection The placement wording to use if there is little space needed
   * @param {string} PopperProperties.moreDirection The placement wording to use if there is more space needed
   */
  function createPopper({ node, rect, lessDirection, moreDirection }) {
    const { nextElementSibling: menu } = node.firstElementChild;
    let placement;
    // Get parent node. Deeply nested submenus will get submenus as parents
    const parentNode = node.parentNode.closest('.popdown, .submenu');
    if (parentNode && parentNode.classList.contains('submenu')) {
      placement = parentNode
        .querySelector(':scope .popdown__menu')
        .getAttribute('x-placement');
    } else {
      // Figure out whether this should be placed on the left/right for submenus or start/end for popdowns
      placement =
        rect.left + rect.width > window.innerWidth / 2
          ? lessDirection
          : moreDirection;
    }

    const popper = new Popper(node, menu, {
      positionFixed: true,
      removeOnDestroy: true,
      placement,
      modifiers: {
        flip: {
          behavior: ['left', 'right'],
        },
        hide: true,
        preventOverflow: {
          boundariesElement: 'window',
        },
      },
      onCreate: () => {
        requestAnimationFrame(() => {
          node.classList.add('active');
          $(document).trigger('popdown:opened', node);
          wrapContents(menu, rect, placement);
        });
      },
    });

    popper.close = () => closePopdown(node);
    const parent = popdownsMap.get(parentNode);
    if (parent) {
      popper.parent = parent;
      parent.child = popper;
    }

    popdownsMap.set(node, Object.assign({}, popper, { parent }));
  }

  function calculatePopoverMaxHeight(placement, clientRect) {
    const offset = 10;

    if (/bottom/.test(placement)) {
      return window.innerHeight - clientRect.bottom - offset;
    } else if (/top/.test(placement)) {
      return clientRect.top - offset;
    } else if (/end/.test(placement)) {
      return window.innerHeight - clientRect.bottom - offset;
    }

    return window.innerHeight - clientRect.top - offset;
  }

  // Wrap menu in a "popdown__inner" element. This is used to fascilitate creating nested submenus that appear
  // outside of the normal overflow area of the parent menu.
  function wrapContents(dropdown, clientRect, placement) {
    if (
      dropdown.firstElementChild &&
      !dropdown.firstElementChild.classList.contains('popdown__inner')
    ) {
      fastdom.mutate(() => {
        // If we are showing the selected menu item, make the menu popover
        // bigger to hold the tick.
        const selectedOffset = dropdown.classList.contains(
          'popdown--show-selected'
        )
          ? 17
          : 0;
        dropdown.style.width = `${dropdown.offsetWidth + selectedOffset}px`;
        dropdown.style.height = `${dropdown.offsetHeight}px`;

        const maxHeight = calculatePopoverMaxHeight(placement, clientRect);
        dropdown.style.maxHeight = `${maxHeight}px`;

        const wrapper = document.createElement('div');
        wrapper.classList.add('popdown__inner');
        Array.from(dropdown.childNodes).forEach(node => {
          wrapper.appendChild(node);
        });
        dropdown.appendChild(wrapper);
        dropdown.classList.add('popdown__menu--has-inner');
        const parent = dropdown.closest('.popdown, .submenu');
        const popdown = popdownsMap.get(parent);

        // Force the popdown to recalculate its position as wrapping nodes can confuse Popper.js
        // Dropdown is initially hiddden so as to prevent element jumping around when update is called.
        if (popdown) popdown.update();
        dropdown.style.visibility = 'visible';
      });
    }
  }

  function unwrapContents(dropdown) {
    if (dropdown) {
      const wrapper = dropdown.querySelector(':scope .popdown__inner');
      if (wrapper) {
        fastdom.mutate(() => {
          dropdown.removeAttribute('style');
          dropdown.removeAttribute('x-placement');
          dropdown.classList.remove('popdown__menu--has-inner');
          Array.from(wrapper.childNodes).forEach(node => {
            dropdown.appendChild(node);
          });
          requestAnimationFrame(() => {
            if (wrapper.parentNode === dropdown) dropdown.removeChild(wrapper);
          });
        });
      }
    }
  }

  $(document)
    .on('mouseenter', '.popdown .submenu', event => {
      const node = event.currentTarget;
      const rect = node.getBoundingClientRect();
      const popdown = popdownsMap.get(node);
      if (popdown) clearTimeout(popdown.leaveTimer);
      createSubmenu(node, rect);
    })
    .on('mouseleave', '.popdown .submenu', event => {
      if ($(event.target).closest('.selectro-trigger').length > 0) {
        return;
      }

      const node = event.currentTarget;
      const popdown = popdownsMap.get(node);
      popdown.leaveTimer = setTimeout(() => {
        closePopdown(node);
      }, 200);
    });

  // Event to open a particular popdown menu.
  $(document).on('popdown:open', '.popdown', event => {
    openPopdown(event.currentTarget);
  });

  // Event to close a particular popdown menu.
  $(document).on('popdown:close', '.popdown', event => {
    closePopdown(event.currentTarget);
  });

  $(document).on('popdown:contextmenu', (e, { x, y, target }) => {
    target.css({
      position: 'fixed',
      left: x,
      top: y,
    });
    openPopdown(target[0]);
  });

  // Close popdown menu when user clicks on a link inside that menu.
  // Normal buttons do not close popdowns, though submit buttons will.
  $(document).on(
    'mouseup',
    '.popdown a, .popdown button[type!="button"], .popdown .popdown__menu__item',
    event => {
      if (
        !isDisabledLink(event.currentTarget) &&
        !isSelectro(event.currentTarget)
      ) {
        const popdown = $(event.currentTarget).closest('.popdown')[0];
        if (popdown.classList.contains('popdown--react')) return;
        closePopdown(popdown);
      }
    }
  );

  // Prevent closing the menu when clicking on a disabled link.
  $(document).on('click ajax:beforeSend', '.popdown a', event => {
    if (isDisabledLink(event.currentTarget)) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
  });

  // Close menu when window resized on turbolinks navigates backwards.
  // This prevents us from having to do expensive position recalculations.
  $(window).on('resize page:restore', event => {
    requestAnimationFrame(() => {
      Array.from(document.querySelectorAll('.popdown.active')).forEach(node => {
        // react_component mounting causes a resize event. It may be undesirable
        // to collapse the menu in that situation. Use the originalEvent
        // attribute of the event to distinguish when the event was triggered
        // by a human.
        if (
          node.getAttribute('data-ignore-react-resize') &&
          !event.originalEvent
        ) {
          return;
        }

        closePopdown(node);
      });
    });
  });
})();
